<template>
  <v-app id="keep">
    <img src="@/assets/EDICTOSMOV.svg" class="hidden-md-and-up" style="width: 100%;">
    <!--<img src="@/assets/BCP_Back.jpg" class="hidden-sm-and-down">-->
    <img src="@/assets/EDICTOSWEB.svg" class="hidden-sm-and-down">
    <!--<div class="hidden-sm-and-down" style="text-align: center; margin-top: -79px;margin-bottom: 11px;">
      <v-toolbar-title style="margin-left:15px;">
        <span class="" style="color:#222222 ;font-weight: bold;font-family: Georgia, 'Book Antiqua', serif;font-size:25px;">
          PODER JUDICIAL DEL ESTADO DE JALISCO
        </span><br/>
        <v-divider inset></v-divider>
        <span class="" style="color:#222222 ;font-weight: bold;font-family: Georgia, 'Book Antiqua', serif;font-size:18px">
          PUBLICACIÓN DE EDICTOS
        </span>
        <br>
      </v-toolbar-title>
    </div>-->
    <div>
      <v-app-bar
        color="#373736"
        dense
        dark
      >
        <v-btn icon to="/edictos">
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn icon href="https://stjjalisco.gob.mx/">
          <img src="@/assets/logo_nuevo.png" style="width:23px;height:23px">
        </v-btn>
        <div v-if="isLoggedIn" class="d-none d-sm-flex">
         <v-btn class="ml-2" to="/edictos" color="#373736">
            EDICTOS
          </v-btn>
          <!-- <v-btn
            class="ml-2 d-sm-and-down"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/reporte"
            color="#373736"
          >REPORTE</v-btn> -->
          <!-- <v-btn
            class="ml-2 d-sm-and-down"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/estadisticas"
            color="#373736"
          >ESTADISTICAS</v-btn> -->
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1"
            to="/users"
            color="#373736"
          >USUARIOS</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1"
            to="/roles"
            color="#373736"
          >ROLES</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1"
            to="/municipios"
            color="#373736"
          >MUNICIPIOS</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1"
            to="/juzgados"
            color="#373736"
          >JUZGADOS</v-btn>
        </div>
        <v-menu
          v-if="isLoggedIn"
          bottom
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="d-flex d-sm-none"
              color="#373736"
              dark
              v-bind="attrs"
              v-on="on"
            >MENÚ</v-btn>
          </template>
          <v-list>
            <v-list-item to="/edictos" class="caption">
              <b>EDICTOS</b>
            </v-list-item>
            <!-- <v-list-item to="/reporte" class="caption">
              <b>REPORTE</b>
            </v-list-item> -->
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/users" class="caption">
              <b>USUARIOS</b>
            </v-list-item>
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/roles" class="caption">
              <b>ROLES</b>
            </v-list-item>          
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/municipios" class="caption">
              <b>MUNICIPIOS</b>
            </v-list-item>
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/juzgados" class="caption">
              <b>JUZGADOS</b>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>
        <v-menu
          v-if="isLoggedIn"
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#373736"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-account</v-icon>
              <span class="d-none d-md-flex d-md-and-up">{{currentUser.name}}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/updatepassword" class="caption">
              <v-icon small class="mr-2">mdi-key</v-icon>
              <b>ACTUALIZAR CONTRASEÑA</b>
            </v-list-item>
            <v-list-item @click="logout" class="caption">
              <v-icon small class="mr-2">mdi-logout</v-icon>
              <b>CERRAR SESIÓN</b>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn icon v-if="isLoggedIn" @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn> -->
        <!--<v-btn icon v-if="!isLoggedIn" to="/login">
          <v-icon>mdi-login</v-icon>
        </v-btn>-->
      </v-app-bar>
    </div>

    <v-main>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>

    <template>
      <v-container>
        <v-card flat>
          <v-divider style="color: #AF8936"></v-divider>
          <v-system-bar
            height="8"
            color="#AF8936"

          ></v-system-bar>
          <v-footer
            color="#FFFFFF"
            padles
          >
          </v-footer>
        </v-card>

      </v-container>
    </template>

  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: false,
      itemsAdmin: [
        { heading: 'Usuarios' },
        { icon: "mdi-account", text: "Usuarios", link: "/users" },
        { icon: "mdi-account-question", text: "Roles", link: "/roles" },
        { icon: "mdi-key", text: "Permisos", link: "/permisos" },
        { divider: true },
      ],
      itemsAdminPerito: [
        { heading: 'Usuarios' },
        { icon: "mdi-account", text: "Usuarios", link: "/users" },
      ],
    }),
    computed: {
      ...mapGetters(["roleUser", "isLoggedIn", "currentUser", 'permisosList'])
    },
    methods: {
      logout() {
        this.$store
          .dispatch("LOGOUT", )
          .then(() => {
            this.$swal({
              title: "Ha cerrado Sesión",
              icon: "success",
              timer: 1000
            }).then(() => {

            });
            window.location = "/"
          })
          .catch(error => {
            this.$swal({
              title: "Error",
              text: "No se pudo Cerrar la Sesión Correctamente",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      }
    }
  }
</script>
